const Search = ({ searchTerm, onSearch, onReset }) => {
  return (
    <div className="uberall-locations__search">
      <input
        type="text"
        placeholder="Standorte filtern"
        value={searchTerm}
        onInput={onSearch}
        className="uberall-locations__search-input"
      />
      <button
        type="button"
        className="btn uberall-locations__search-reset"
        onClick={onReset}
      >
        Zurücksetzen
      </button>
    </div>
  );
};

export default Search;
